import React from 'react';
import { Box, Typography, Stack, Paper } from '@mui/material';
import type { QuestionAnswer } from '@components/ui/dashboard/ApplicantReview/types/candidate';

interface AssessmentSectionProps {
  questions: QuestionAnswer[];
}

export const AssessmentSection: React.FC<AssessmentSectionProps> = ({ questions }) => {
  if (questions.length === 0) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        py={6}
        sx={{ color: '#A0A7B1' }}
      >
        <Typography variant="body1" fontWeight="medium">
          No questions available
        </Typography>
        <Typography variant="body2" mt={0.5}>
          There are no assessment questions for this applicant.
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={2}>
      {questions.map((item) => (
        <Paper
          key={item.id}
          elevation={0}
          sx={{
            p: 3,
            backgroundColor: '#121316',
            border: '1px solid #23262d',
            borderRadius: 2,
          }}
        >
          <Box display="flex" gap={2} alignItems="flex-start">
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: '#2A2415',
                color: '#0a66c2',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 'bold',
                flexShrink: 0,
                mt: 0.3,
              }}
            >
              {item.id}
            </Box>
            <Box>
              <Typography variant="subtitle2" fontWeight="bold" color="#FFFFFF" mb={1}>
                {item.question}
              </Typography>
              <Typography variant="body2" color="#A0A7B1" sx={{ lineHeight: 1.6 }}>
                {item.answer}
              </Typography>
            </Box>
          </Box>
        </Paper>
      ))}
    </Stack>
  );
};